<template>
  <transition name="scale">
    <div class="modal-backdrop"
         @click.self="close"
         v-if="show">
      <div class="modal"
           :style="style">
        <header class="modal-header"
                v-if="hasHeader">
          <slot name="header"></slot>

          <icon-cross width="32"
                      height="32"
                      color="#fff"
                      class="btn-close"
                      @click="close"
                      v-if="showCloseButton" />
        </header>

        <VuePerfectScrollbar class="modal-body"
                             :class="bodyClasses">
          <slot></slot>
        </VuePerfectScrollbar>

        <footer class="modal-footer"
                v-if="hasFooter">
          <slot name="footer"></slot>
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'

  export default {
    props: {
      show: {
        required: false,
        type: Boolean,
        default: false
      },

      showCloseButton: {
        required: false,
        type: Boolean,
        default: true
      },

      size: {
        type: String,
        required: false
      },

      height: {
        required: false
      },

      padding: {
        type: Boolean,
        required: false,
        default: true
      }
    },

    components: {
      VuePerfectScrollbar
    },

    created() {
      const escapeHandler = e => {
        if (e.key === 'Escape' && this.show) {
          this.close()
        }
      }

      document.addEventListener('keydown', escapeHandler)
      this.$once('hook:destroyed', () => {
        document.removeEventListener('keydown', escapeHandler)
      })

      if (this.show) {
        document.body.classList.add('modal-opened')
      }
    },

    methods: {
      onOpen() {
        document.body.classList.add('modal-opened')
      },

      onClose() {
        document.body.classList.remove('modal-opened')
      },

      close() {
        this.onClose()
        this.$emit('close')
      }
    },

    computed: {
      hasHeader() {
        return Boolean(this.$slots.header)
      },

      hasFooter() {
        return Boolean(this.$slots.footer)
      },

      style() {
        let modalSizes = {
          small: '550px',
          medium: '700px',
          default: '550px'
        }

        return {
          width: modalSizes[this.size] || modalSizes.default,
          height: this.height ? `${this.height}px` : 'auto',
        }
      },

      bodyClasses() {
        return {
          'modal-body-padding': this.padding
        }
      }
    },

    watch: {
      show() {
        this.$nextTick(() => {
          if (this.show) {
            this.onOpen()
          } else {
            this.onClose()
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index:  999;
    background-color: rgba(#000,.9);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .modal {
    display: flex;
    flex-direction: column;

    background-color: #fff;
    border: 1px solid #eee;
    border-radius: 8px;
  }

  .modal-header,
  .modal-footer {
    display: flex;
  }

  .modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    height: 70px;
    min-height: 70px;
    padding: 0 32px;

    font-size: 20px;
    color: map.get($colors, primary);
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
  }

  .modal-body {
    position: relative;
    flex: 1 1 auto;
    padding: 0;

    max-height: 700px;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .modal-body-padding {
    padding: 20px 30px;
  }

  .btn-close {
    position: absolute;
    right: -35px;
    top: -35px;
    cursor: pointer;
  }

  .modal-fade-enter,
  .modal-fade-leave-active {
    opacity: 0;
  }

  .modal-fade-enter-active,
  .modal-fade-leave-active {
    transition: opacity .5s ease
  }
</style>
